import { tx, txt, useContent } from "@/content/ContentContext";
import { BrandMark } from "@/components/AppShell";

const TAPE = () => ([
  [tx("login.panadol_500mg_x20"), tx("login.2_x_0_150"), "0.300"],
  [tx("login.b_pn_26094_exp_12"), "", ""],
  [tx("login.basmati_rice_1kg"), tx("login.1_x_420_00"), "420.00"],
  [tx("login.coca_cola_1_5l"), tx("login.3_x_220_00"), "660.00"],
]);

export default function AuthLayout({ title, subtitle, children, compact }) {
  useContent();
  return (
    <div className="grid min-h-[100dvh] bg-slate-50 lg:grid-cols-[1.05fr_1fr]">
      <aside className="grain relative hidden overflow-hidden bg-slate-950 p-12 lg:flex lg:flex-col">
        <BrandMark />
        <div className="mt-auto max-w-md">
          <div className="eyebrow !text-amber-400">{txt("login.cloud_point_of_sale")}</div>
          <h1 className="mt-4 font-display text-5xl font-extrabold leading-[1.02] tracking-tight text-white">
            {txt("login.ring_up_the_first_sale")}<br />
            <span className="text-amber-400">{txt("login.before_the_kettle_boils")}</span>
          </h1>
          <p className="mt-5 text-base leading-relaxed text-slate-400">
            {txt("login.scanner_ready_thermal_printer_ready")}
          </p>
        </div>
        <div className="pointer-events-none absolute right-10 top-20 w-72 rotate-[4deg] xl:right-20" aria-hidden="true">
          <div className="slot mb-1" />
          <div className="tape mx-3 px-5 py-6 font-mono text-[11px] text-slate-700">
            <div className="text-center font-bold tracking-widest">{txt("login.karachi_fresh_mart")}</div>
            <div className="mt-1 text-center text-[10px] text-slate-400">{txt("login.main_000128_14_02")}</div>
            <div className="dash-rule my-3" />
            {TAPE().map(([a, b, c], i) => (
              <div key={i} className={`flex justify-between gap-2 ${b ? "mt-1.5" : "text-[9.5px] text-amber-600"}`}>
                <span className="truncate">{a}{b && <span className="block text-slate-400">{b}</span>}</span>
                <span className="tabular-nums">{c}</span>
              </div>
            ))}
            <div className="dash-rule my-3" />
            <div className="flex justify-between text-[13px] font-bold"><span>{txt("login.total_pkr")}</span><span>1,080.30</span></div>
            <div className="flex justify-between text-slate-400"><span>{txt("login.sales_tax_18_incl")}</span><span>164.79</span></div>
          </div>
        </div>
        <div className="absolute bottom-0 right-0 h-72 w-72 translate-x-1/3 translate-y-1/3 rounded-full bg-amber-500/20 blur-[100px]" />
      </aside>
      <section className={`flex flex-col px-5 sm:px-10 ${compact ? "py-4" : "py-8"}`}>
        <div className="lg:hidden"><BrandMark light={false} /></div>
        <div className={`mx-auto my-auto w-full max-w-md ${compact ? "py-2" : "py-10"}`}>
          <h2 className="font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">{title}</h2>
          <p className="mt-2 text-sm text-slate-500 sm:text-base">{subtitle}</p>
          <div className={compact ? "mt-5" : "mt-8"}>{children}</div>
        </div>
      </section>
    </div>
  );
}
